<app-navbar />

@if (article(); as post) {
  <main id="main-content">
    <section class="page-hero article-hero">
      <div class="container">
        <app-breadcrumb [trail]="[{ label: 'Resources', url: routes.resources.url }, { label: post.category }]" />
        <span class="eyebrow">{{ post.category }}</span>
        <h1>{{ post.title }}</h1>
        <p>{{ post.excerpt }}</p>
        <div class="article-hero-meta">
          <span>{{ post.audience }}</span>
          <span class="article-dot" aria-hidden="true"></span>
          <span>{{ post.readMinutes }} min read</span>
          <span class="article-dot" aria-hidden="true"></span>
          <span>Updated {{ formatDate(post.updated) }}</span>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="article-layout">
          <aside class="article-toc">
            <p class="article-toc-title">On this page</p>
            <nav>
              @for (section of post.sections; track section.heading) {
                <a [routerLink]="[]" [fragment]="anchorFor(section.heading)">{{ section.heading }}</a>
              }
              <a [routerLink]="[]" fragment="questions">Common questions</a>
            </nav>
            <div class="article-toc-cta">
              <span class="article-toc-cta-title">Test it on your own data</span>
              <p>Pay only for confirmed matches. No minimum, no contract to start.</p>
              <a class="btn btn-primary btn-sm" [routerLink]="[routes.accountRegister.url]">Start free</a>
            </div>
          </aside>

          <div class="article-body">
            <div class="takeaway-panel">
              <span class="takeaway-title">Key takeaways</span>
              <ul>
                @for (point of post.keyTakeaways; track point) {
                  <li>{{ point }}</li>
                }
              </ul>
            </div>

            <article class="prose article-prose">
              @for (section of post.sections; track section.heading) {
                <h2 [id]="anchorFor(section.heading)">{{ section.heading }}</h2>

                @for (paragraph of section.paragraphs; track paragraph) {
                  <p>{{ paragraph }}</p>
                }

                @if (section.bullets?.length) {
                  <ul class="article-list">
                    @for (bullet of section.bullets; track bullet) {
                      <li>{{ bullet }}</li>
                    }
                  </ul>
                }

                @if (section.callout; as callout) {
                  <aside class="article-callout">
                    <span class="article-callout-title">{{ callout.title }}</span>
                    <p>{{ callout.body }}</p>
                  </aside>
                }
              }

              <h2 id="questions">Common questions</h2>
              <div class="article-faqs">
                @for (faq of post.faqs; track faq.question) {
                  <details class="article-faq">
                    <summary>{{ faq.question }}</summary>
                    <p>{{ faq.answer }}</p>
                  </details>
                }
              </div>
            </article>

            <div class="article-cta">
              <div>
                <h2>See what this looks like in your portfolio</h2>
                <p>
                  Upload a sample file or call the API and get confirmed deceased matches with date
                  of death, age and last known address. You are only charged for records we confirm.
                </p>
              </div>
              <div class="actions-row">
                <a class="btn btn-primary btn-lg" [routerLink]="[routes.accountRegister.url]">Start free</a>
                <a class="btn btn-outline btn-lg" [routerLink]="[routes.bookACall.url]">Talk to our team</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    @if (related().length) {
      <section class="section section-alt">
        <div class="container">
          <div class="section-head">
            <span class="eyebrow">Keep reading</span>
            <h2 class="section-title">Related guides</h2>
          </div>
          <div class="related-grid">
            @for (item of related(); track item.slug) {
              <a class="article-card" [routerLink]="[routes.resources.url, item.slug]">
                <span class="icon-badge" aria-hidden="true" [innerHTML]="iconFor(item.icon)"></span>
                <span class="tag">{{ item.category }}</span>
                <h3>{{ item.title }}</h3>
                <p>{{ item.excerpt }}</p>
                <div class="article-foot">
                  <span>{{ item.readMinutes }} min read</span>
                </div>
              </a>
            }
          </div>
        </div>
      </section>
    }
  </main>
}

<app-footer />
